<template>
	<div
		class="asmnt-white-card d-flex"
		:class="{
			'w-100':
				(fromJobSearch === 'main' && isLaptop) ||
				(fromAsmntprogress && !isLaptop) ||
				(fromAsmntprogress && isLaptop) ||
				fromAsmnttestcard ||
				fromJobSearchpage,
		}"
		@mouseenter="isLaptop && startMarquee()"
		@mouseleave="isLaptop && stopMarquee()"
	>
		<div class="d-flex flex-column gap-2 w-100">
			<div class="d-flex align-items-center">
				<img :src="cardIcon" alt="" />
				<div
					class="d-flex flex-column ml-2"
					:class="{
						'w-87': !fromAsmntprogress,
						'w-100': fromAsmntprogress,
						'w-80': tooltipText && fromJobSearchpage,
					}"
				>
					<div class="d-flex align-items-center justify-content-between">
						<!-- :class="{
							'w-92': fromAsmntprogress && isLaptop && tooltipText,
						}" -->
						<div
							class="fw-M fs-15 fam-mont color-testname d-flex mob-fs-13 capitalize-first"
							:class="
								!isLaptop && assessment.leaderboard
									? 'w-90'
									: !isLaptop
									? 'w-100'
									: !assessment.leaderboard && !fromAsmntprogress
									? 'w-100'
									: fromAsmntprogress && !tooltipText
									? 'w-70'
									: 'w-95'
							"
						>
							<span
								class="text-truncate pr-1 capitalize-first"
								ref="testName"
								v-b-tooltip.hover="tooltipText"
								>{{ assessment.testName }}</span
							>
						</div>
						<img
							src="@/assets/assessment/leaderboardcup.svg"
							v-if="assessment.leaderboard"
							alt=""
						/>

						<!-- <img src="../../assets/assessment/pendingtime.svg" alt="" /> -->
					</div>
					<div class="d-flex align-items-center justify-content-between">
						<div
							class="color-topicname fam-lato d-flex align-items-center w-75 mt-8px"
						>
							<!-- <span class="fs-13 fw-R flex-shrink-0 mr-1 mob-fs-12"
								>Topic Name :</span
							> -->

							<span
								class="fs-15 fw-R topic-truncate mob-fs-12 capitalize-first"
								:title="assessment.topicName"
							>
								{{ assessment.topicName }}
							</span>
						</div>
						<!-- <div
							class="attempted-tag fam-lato fw-LM fs-12 color-attempted d-flex align-items-center justify-content-center"
							v-if="
								hasAccess() &&
								attemptedTag &&
								fromAsmntprogress &&
								assessment.maxnoattempts > 1 &&
								assessment.noOfAttemptsTaken < assessment.maxnoattempts &&
								isLaptop
							"
						>
							Attempted {{ assessment.noOfAttemptsTaken }}/{{
								assessment.maxnoattempts
							}}
						</div> -->
					</div>
				</div>
			</div>
			<div class="dashed-divider-asmntcard"></div>
			<div class="d-flex justify-content-between mt-1">
				<div
					class="tagline-width-6050"
					:class="
						cardType === 'upcoming'
							? 'w-datetime-upcoming'
							: fromAsmnttestcard || fromJobSearchpage || fromSidepanel
							? 'w-55'
							: 'tagline-width-6050'
					"
				>
					<div
						class="d-flex align-items-center gap-2 color-tagline fs-14 fam-lato fw-LM w-100"
					>
						<img
							v-if="assessment.tagline"
							src="../../assets/assessment/greenflash.svg"
							alt=""
						/>

						<div class="tagline-container">
							<span
								ref="tagline"
								class="tagline-text"
								:class="{ marquee: marqueeActive }"
							>
								{{ assessment.tagline }}
							</span>
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-between mt-5px">
						<div class="text-3A3C40 fam-mont d-flex align-items-center">
							<span class="fs-12 fw-R">
								<img src="../../assets/assessment/hourglass.svg" alt="" />
								{{ assessment.config.testDuration }} Min
							</span>
							<img
								src="../../assets/assessment/categories/line.svg"
								class="mx-2"
								alt=""
							/>
							<span class="fs-12">
								<img src="../../assets/assessment/level.svg" alt="" />
								<span class="fw-R">Level : </span>
								<span class="fw-LM">0{{ assessment.intDifficulty }}</span>
							</span>
						</div>
					</div>
					<section class="mt-5px">
						<div
							class="asmnt-completed-tag fam-lato fw-LM fs-12 text-completed d-flex align-items-center justify-content-center"
							v-if="assessment.attemptsLeft == 0 && cardType != 'ongoing'"
						>
							Completed
						</div>

						<div
							class="purchase-tag fam-lato fw-LM fs-12 text-blue d-flex align-items-center justify-content-center"
							v-else-if="
								assessment.purchased === true &&
								assessment.noOfAttemptsTaken == 0
							"
						>
							Purchased
						</div>
						<div
							v-else-if="
								(assessment.setPricing == null ||
									assessment.setPricing == undefined ||
									assessment.setPricing === false) &&
								assessment.noOfAttemptsTaken == 0
							"
							class="fam-mont fw-B fs-13 text-blue"
							style="width: fit-content"
						>
							FREE
						</div>

						<div
							style="width: fit-content"
							v-else-if="
								assessment.setPricing === true && assessment.purchased === false
							"
							class="fam-lato fw-LM fs-12 text-blue"
						>
							<span
								class="fam-mont fw-B fs-13 text-blue"
								v-if="assessment.finalPrice === assessment.listPrice"
							>
								₹{{ assessment.finalPrice }}</span
							>
							<template v-else>
								<span class="fam-mont fw-B fs-13 text-blue">
									₹{{ assessment.finalPrice }}</span
								>
								<span class="text-strike-price fam-mont">
									₹{{ assessment.listPrice }}
								</span>
							</template>
						</div>
						<div
							class="attempted-tag fam-lato fw-LM fs-12 color-attempted d-flex align-items-center justify-content-center"
							v-else-if="
								hasAccess() &&
								assessment.noOfAttemptsTaken < assessment.maxnoattempts
							"
						>
							Attempted {{ assessment.noOfAttemptsTaken }}/{{
								assessment.maxnoattempts
							}}
						</div>
					</section>
				</div>
				<div
					class="d-flex flex-column"
					:class="
						(assessment.noOfAttemptsTaken != 0 &&
							assessment.noOfAttemptsTaken < assessment.maxnoattempts) ||
						cardType === 'upcoming' ||
						cardType == 'ongoing'
							? 'wenbothbtns-present'
							: 'wensinglebtn-present'
					"
				>
					<div
						v-if="
							(assessment.noOfAttemptsTaken != 0 &&
								assessment.noOfAttemptsTaken < assessment.maxnoattempts) ||
							cardType === 'upcoming' ||
							cardType == 'ongoing'
						"
					>
						<div
							v-if="
								assessment.noOfAttemptsTaken != 0 &&
								assessment.noOfAttemptsTaken < assessment.maxnoattempts
							"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer"
							@click="handleViewMarks(assessment)"
						>
							View Marks
							<img
								src="../../assets/assessment/viewmarks.svg"
								class="ml-1"
								alt=""
							/>
						</div>
						<div
							class="d-flex align-items-center text-blue fs-12 fam-mont"
							v-else-if="cardType === 'upcoming' || cardType == 'ongoing'"
						>
							<img
								class="mr-2"
								src="../../assets/newdesign/assessPro/smallCalen.svg"
								alt=""
							/>
							<span class="text-3A3C40">
								{{ formatTime(assessment.config?.openTestdt) }},
								{{ formatDate(assessment.config?.openTestdt) }}
							</span>
						</div>
					</div>
					<section>
						<div
							v-if="cardType == 'ongoing'"
							@click="viewTestDetails(assessment, 'private')"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer"
						>
							Re-join
							<img
								class="ml-1"
								src="../../assets/newdesign/assessPro/blueRightArrow.svg"
								alt=""
							/>
						</div>

						<div
							v-else-if="
								assessment.attemptsLeft != 0 &&
								assessment.setPricing == true &&
								assessment.purchased != true
							"
							@click="viewTestDetailsModal()"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer ml-3"
						>
							<b-button class="candash-addBtn purchasetestbtn-p15px">
								Purchase Test</b-button
							>
						</div>
						<div
							v-else-if="
								assessment.noOfAttemptsTaken != 0 &&
								assessment.attemptsLeft != 0
							"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer"
							@click="viewTestDetailsModal()"
						>
							<b-button class="candash-addBtn padding624px">
								Re-take Test
								<!-- <img
								class="ml-1"
								src="../../assets/newdesign/assessPro/blueRightArrow.svg"
								alt=""
						/> -->
							</b-button>
						</div>
						<div
							v-else-if="assessment.noOfAttemptsTaken != 0"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer"
							@click="handleViewMarks(assessment)"
						>
							View Marks
							<img
								src="../../assets/assessment/viewmarks.svg"
								class="ml-2"
								alt=""
							/>
						</div>
						<div
							v-else-if="assessment.attemptsLeft != 0"
							@click="viewTestDetailsModal()"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer ml-3"
						>
							<b-button class="candash-addBtn padding624px">
								{{
									cardType === "upcoming" &&
									isUpcoming(assessment) &&
									assessment.setPricing === false
										? "Notify Me"
										: assessment.attemptsLeft > 1 &&
										  assessment.noOfAttemptsTaken != 0
										? assessment.attemptsLeft + " Attempts left"
										: "Take Test"
								}}
							</b-button>

							<!-- <img
							class="ml-1"
							src="../../assets/newdesign/assessPro/blueRightArrow.svg"
							alt=""
						/> -->
						</div>

						<div
							v-else-if="
								cardType === 'upcoming' &&
								(assessment.setPricing == false ||
									assessment.setPricing == null ||
									assessment.purchased == true)
							"
							class="text-blue fam-mont fw-M fs-13 d-flex align-items-center pointer"
							@click="viewTestDetails(assessment, 'private')"
						>
							<b-button class="candash-addBtn padding624px">{{
								isUpcoming(assessment) ? "Notify Me" : "Take Test"
							}}</b-button>
							<!-- <img
							class="ml-1"
							src="../../assets/newdesign/assessPro/blueRightArrow.svg"
							alt=""
						/> -->
						</div>
					</section>
				</div>
			</div>
		</div>

		<AssessmentMarksModal
			:showMarks="showAssessmentMarks"
			:selectedAssessment="selectedAssessment"
			:isPublic="isPublic"
			@closeModal="showAssessmentMarks = false"
			@take-next-attempt="
				viewTestDetails(
					selectedAssessment,
					isPublic == true ? 'public' : 'private'
				)
			"
		/>
		<TestDetails
			ref="testDetails"
			v-if="showTestDetails && isLaptop"
			:showTestDetails="showTestDetails"
			:selectedAssessment="selectedAssessment"
			:public="isPublic"
			@closeTestModal="showTestDetails = false"
			:cardType="cardType"
			@purchase-success="handlePurchaseSuccess"
		/>
		<TestDetailsMobile
			ref="testDetails"
			v-if="showTestDetails && !isLaptop"
			:showMobileTestDetails="showTestDetails"
			:selectedAssessment="selectedAssessment"
			:public="isPublic"
			:cardType="cardType"
			@purchase-success="handlePurchaseSuccess"
		/>

		<div style="display: none" ref="responseContainer"></div>
	</div>
</template>

<script>
import AssessmentMarksModal from "@/views/AssessmentProgress/AssessmentMarksModal.vue";
import assessmentProgress from "../mixin/assessmentProgress";
import TestDetails from "@/views/AssessmentProgress/TestDetailsAP.vue";
import TestDetailsMobile from "../../views/AssessmentProgress/TestDetailsMobile.vue";
import { hasAccess } from "@/utils/tokenCheck";

export default {
	props: {
		assessment: {
			type: Object,
			required: true,
		},
		fromAsmntprogress: {
			type: Boolean,
			default: false,
		},
		cardType: {
			type: String,
			default: "default", // default, completed, upcoming, ongoing
		},

		isProject: {
			type: Boolean,
			default: false,
		},
		fromJobSearch: {
			type: String,
			default: "",
		},
		fromJobSearchpage: {
			type: Boolean,
			default: false,
		},
		attemptedTag: {
			type: Boolean,
			default: false,
		},
		fromAsmnttestcard: {
			type: Boolean,
			default: false,
		},
		fromSidepanel: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		tooltipText() {
			return this.isNameTruncated ? this.assessment.testName : null;
		},

		cardIcon() {
			const isProject =
				this.isProject ||
				(this.assessment.topicName &&
					this.assessment.topicName.includes("Sandbox"));

			return isProject
				? require("../../assets/assessment/mobprojecticon.svg")
				: require("../../assets/assessment/mobcardasmnticon.svg");
		},
		hasRightContent() {
			return (
				(this.assessment.noOfAttemptsTaken != 0 &&
					this.assessment.noOfAttemptsTaken < this.assessment.maxnoattempts) ||
				this.cardType === "upcoming" ||
				this.cardType === "ongoing"
			);
		},
	},
	mixins: [assessmentProgress],
	components: {
		AssessmentMarksModal,
		TestDetails,
		TestDetailsMobile,
	},
	data() {
		return {
			isLaptop: true,
			isNameTruncated: false,
			isTaglineTruncated: false,
			taglineDistance: 0,
			marqueeActive: false,
		};
	},
	watch: {
		"assessment.testName": {
			handler() {
				setTimeout(() => this.checkTruncate(), 50);
			},
			immediate: true,
		},
		"assessment.tagline": {
			handler() {
				this.checkTagline();
			},
			immediate: true,
		},
	},
	mounted() {
		this.checkTagline();
		this.checkTruncate();
		window.addEventListener("resize", this.checkTruncate);
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
		if (!this.isLaptop) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting && this.isTaglineTruncated) {
							this.marqueeActive = true;
						} else {
							this.marqueeActive = false;
						}
					});
				},
				{
					threshold: 0.7, // 70% visible
				}
			);

			observer.observe(this.$el);

			this.observer = observer;
		}
	},
	beforeDestroy() {
		this.observer?.disconnect();
		window.removeEventListener("resize", this.checkTagline);

		window.removeEventListener("resize", this.checkTruncate);
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkTagline() {
			this.$nextTick(() => {
				const el = this.$refs.tagline;

				if (!el) return;

				this.isTaglineTruncated = el.scrollWidth > el.clientWidth;

				this.taglineDistance = el.scrollWidth - el.clientWidth;
			});
		},
		startMarquee() {
			if (!this.isTaglineTruncated) return;

			this.marqueeActive = true;
		},

		stopMarquee() {
			this.marqueeActive = false;
		},
		hasAccess() {
			return hasAccess();
		},
		handlePurchaseSuccess() {
			this.assessment.purchased = true;
		},
		checkTruncate() {
			this.$nextTick(() => {
				const el = this.$refs.testName;
				if (!el) return;

				this.isNameTruncated = el.scrollWidth > el.clientWidth;
			});
		},
		handleViewMarks(assessment) {
			if (this.isLaptop) {
				this.viewMarks(assessment, assessment?.config?.test);
			} else {
				this.viewMarks(assessment);
			}
		},
		viewTestDetailsModal() {
			if (this.isLaptop) {
				this.viewTestDetails(this.assessment, "private");
			} else {
				this.viewTestDetails(
					this.assessment,
					"noPublic",
					true,
					this.isPublicMob
				);
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		isUpcoming(assessment) {
			const openTime = new Date(assessment.config?.openTestdt).getTime();
			const now = Date.now();
			return openTime > now;
		},
	},
};
</script>

<style>
.tagline-container {
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	white-space: nowrap;
	position: relative;
}

.tagline-text {
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
	vertical-align: top;
}

.tagline-text.marquee {
	max-width: none;
	overflow: visible;
	text-overflow: unset;
	animation: marquee 5s linear infinite;
}

.marquee {
	animation: marquee 3s linear infinite;
}

@keyframes marquee {
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(-150px);
	}
}
.text-completed {
	color: #038e00;
}
.asmnt-white-card {
	padding: 12px;
	width: clamp(300px, calc(100vw - 40px), 420px);
	min-height: 165px;
	height: auto;
	background: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	flex-shrink: 0;
}
.asmnt-completed-tag {
	padding: 4px 20px;
	background: rgba(3, 142, 0, 0.1);
	border-radius: 4px;
	width: fit-content;
}
.asmnt-featured-tag {
	padding: 4px 12px;
	background: linear-gradient(
		90deg,
		rgba(32, 99, 155, 0.4004) -59.37%,
		rgba(32, 99, 155, 0.77) 100%
	);
	backdrop-filter: blur(1.91214px);
	border-radius: 4px;
}
.w-85 {
	width: 86%;
}
.topic-truncate {
	display: block;
	max-width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.purchase-tag {
	padding: 4px 20px;
	background: rgba(32, 99, 155, 0.11);
	border-radius: 4px;
	width: fit-content;
}
.attempted-tag {
	padding: 4px 20px;
	background: rgba(255, 183, 80, 0.08);
	border-radius: 4px;
	width: fit-content;
}
.color-attempted {
	color: #c04800;
}
.text-strike-price {
	font-weight: 400;
	font-size: 13px;
	text-decoration-line: line-through;
	color: #999999;
}
.h-100px {
	height: 100px;
}
.h75px {
	height: 75px;
}
.red-dot-filter {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0px 4px;
	width: 16px;
	min-width: 16px;
	max-width: 34px;
	height: 16px;
	background: #b3261e;
	border-radius: 100px;
	top: -3px;
	right: -5px;
}
.tagline-width-6050 {
	width: clamp(220px, 65%, 300px);
}
.padding624px {
	padding: 6px 24px !important;
}
.purchasetestbtn-p15px {
	padding: 6px 15px !important;
}
@media only screen and (max-width: 1028px) {
	.asmnt-white-card {
		width: min(100vw - 40px, 350px);
		align-self: flex-start;
	}
	.attempted-tag {
		padding: 4px 10px;
	}
	.mob-ml-12 {
		margin-left: 12px;
	}
	.tagline-width-6050 {
		width: clamp(150px, 53%, 210px);
	}
	.w-datetime-upcoming {
		width: clamp(140px, 50%, 200px);
	}
}
.w-95 {
	width: 95%;
}
.w-70 {
	width: 70%;
}
.dashed-divider-asmntcard {
	display: block;
	width: 100%;
	height: 1px;
	min-height: 1px;

	background-image: repeating-linear-gradient(
		to right,
		#cecece 0px,
		#cecece 5px,
		transparent 0px,
		transparent 10px
	);
}
.mt-8px {
	margin-top: 5px;
}
.color-testname {
	color: #111827;
}
.color-topicname {
	color: #4b5563;
}
.w-92 {
	width: 92%;
}
.color-tagline {
	color: #059669;
}
.w-82 {
	width: 82%;
}
.w-87 {
	width: 87%;
}
.mt-5px {
	margin-top: 5px;
}
.wenbothbtns-present {
	justify-content: space-between;
	align-items: flex-end;
	flex-shrink: 0;
	max-width: none;
}
.wensinglebtn-present {
	justify-content: flex-end;
	align-items: flex-end;
	flex-shrink: 0;
	max-width: none;
}
.w-55 {
	width: clamp(180px, 55%, 260px);
}
.w-datetime-upcoming {
	width: clamp(180px, 60%, 260px);
}
</style>
